export default class PriceHelpers {
  static hoursOfModule(module, columns, projectRate) {
    return module.components
      .reduce((acc, x) => {
        acc += PriceHelpers.hoursOfCom(x, columns, projectRate);
        return acc;
      }, 0);
  }
  static priceOfModule(module, columns, projectRate) {
    return module.components
      .reduce((acc, x) => {
        acc += PriceHelpers.priceOfCom(x, columns, projectRate);
        return acc;
      }, 0);
  }
  static priceOfCom (component, columns, projectRate) {
    const quantity = component.moduleColumns.metaElements[2]['mid']
    let total = component.moduleColumns.fixedElements
      .filter((element, index) => !columns.fixedElements[index].disabled)
      .reduce((acc, x) => {
        acc += quantity * x['mid'];
        return acc;
      }, 0)
    const startingTotal = PriceHelpers.hourlyHoursOfCom(component, columns)
    if (component.moduleColumns.hourlyElements && component.moduleColumns.hourlyElements.length) {
      total += component.moduleColumns.hourlyElements
        .reduce((acc, x, index) => {
          if (!columns.hourlyElements[index].disabled) {
            const rate = columns.hourlyElements[index].hourlyRateOverride && columns.hourlyElements[index].useTaskRate ?
              columns.hourlyElements[index].hourlyRateOverride : projectRate
            acc += quantity * x['mid'] * rate;
          }
          return acc;
        }, 0);
    }
    if (component.moduleColumns.percentTasks && component.moduleColumns.percentTasks.length) {
      total += component.moduleColumns.percentTasks
        .reduce((acc, x, index) => {
            if (!columns.percentTasks[index].disabled) {
              let percent = columns.percentTasks[index].taskPercentOverride
              if (x['mid']) {
                percent = x['mid']
              }
              if (percent) {
                const rate = columns.percentTasks[index].hourlyRateOverride && columns.percentTasks[index].useTaskRate ?
                columns.percentTasks[index].hourlyRateOverride : projectRate
                acc += startingTotal * (percent / 100) * rate;
              }
            }
            return acc;
          }, 0);
    }
    return total
  }

  static hoursOfCom(component, columns) {
    const startingTotal = PriceHelpers.hourlyHoursOfCom(component, columns)
    const percentTasks = component.moduleColumns.percentTasks
    if (!startingTotal || !percentTasks || !percentTasks.length) {
      return startingTotal
    }
    const percentTotal = component.moduleColumns.percentTasks
      .filter((element, index) => !columns.percentTasks[index].disabled)
      .reduce((acc, x, index) => {
          let percent = columns.percentTasks[index].taskPercentOverride
          if (x['mid']) {
            percent = x['mid']
          }
          if (percent) {
            acc += startingTotal * (percent / 100);
          }
          return acc;
        }, 0);
    return startingTotal + percentTotal;
  }

  static hourlyHoursOfCom(component, columns) {
    const quantity = component.moduleColumns.metaElements[2]['mid']
    if (component.disabled) {
      return 0
    }
    const hourlyElements = component.moduleColumns.hourlyElements
    if (!hourlyElements || !hourlyElements.length) {
      return 0
    }
    return hourlyElements
      .filter((element, index) => !columns.hourlyElements[index].disabled)
      .reduce((acc, x) => {
          acc += quantity * x['mid'];
          return acc;
        }, 0);
  }

}
